import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bd1d9302")

_pushScopeId("data-v-bd1d9302")
const _hoisted_1 = {
  key: 0,
  class: "alert alert-warning mb-4"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Add AI credits")
const _hoisted_3 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Platforms", -1)
const _hoisted_5 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold required" }, "What this post is about", -1)
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "What you want people to do", -1)
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold mb-1" }, "How many captions should we generate?", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-3" }, " Choose how many versions AI should write. You'll pick one to use in your post. More options use more AI credits. ", -1)
const _hoisted_13 = { class: "d-flex flex-column gap-2" }
const _hoisted_14 = { class: "flex-grow-1" }
const _hoisted_15 = { class: "fw-semibold d-block" }
const _hoisted_16 = { class: "text-muted fs-8" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "text-muted fs-8 mb-3" }
const _hoisted_19 = { class: "card-body p-3" }
const _hoisted_20 = { class: "d-flex align-items-start justify-content-between gap-3" }
const _hoisted_21 = { class: "flex-grow-1" }
const _hoisted_22 = { class: "text-muted fs-8 mb-1" }
const _hoisted_23 = { class: "suggest-caption-dialog__draft-text" }
const _hoisted_24 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin me-1" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Generating… ")
const _hoisted_28 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.visible = $event)),
    title: _ctx.dialogTitle,
    width: "520px",
    "destroy-on-close": "",
    onClosed: _ctx.onClosed
  }, {
    footer: _withId(() => [
      _createVNode("button", {
        type: "button",
        class: "btn btn-light",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, " Cancel "),
      (!_ctx.drafts.length)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary ms-2",
            disabled: _ctx.generating || !_ctx.form.topic.trim(),
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
          }, [
            (_ctx.generating)
              ? (_openBlock(), _createBlock("span", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_28, "Suggest caption"))
          ], 8, ["disabled"]))
        : (_openBlock(), _createBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-light-primary ms-2",
            disabled: _ctx.generating,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.regenerate && _ctx.regenerate(...args)))
          }, " Try again ", 8, ["disabled"]))
    ]),
    default: _withId(() => [
      (_ctx.creditsError)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.creditsError) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/settings/ai247-portal",
              class: "fw-bold ms-1"
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.drafts.length)
        ? (_openBlock(), _createBlock("form", {
            key: 1,
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)), ["prevent"]))
          }, [
            (_ctx.platformLabels.length)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.platformLabels, (label) => {
                      return (_openBlock(), _createBlock("span", {
                        key: label,
                        class: "badge badge-light-primary"
                      }, _toDisplayString(label), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.topic = $event)),
                class: "form-control",
                rows: "4",
                placeholder: "Describe the product, event, or message you want to share",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.topic]
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.intent = $event)),
                class: "form-control",
                rows: "2",
                placeholder: "Optional — e.g. message me, visit my link, learn more"
              }, null, 512), [
                [_vModelText, _ctx.form.intent]
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.draftCountOptions, (option) => {
                  return (_openBlock(), _createBlock("label", {
                    key: option.value,
                    class: ["suggest-caption-dialog__count-option", { 'suggest-caption-dialog__count-option--active': _ctx.form.draftCount === option.value }]
                  }, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.draftCount = $event)),
                      type: "radio",
                      class: "form-check-input mt-1 flex-shrink-0",
                      value: option.value
                    }, null, 8, ["value"]), [
                      [_vModelRadio, _ctx.form.draftCount]
                    ]),
                    _createVNode("span", _hoisted_14, [
                      _createVNode("span", _hoisted_15, _toDisplayString(option.label), 1),
                      _createVNode("span", _hoisted_16, _toDisplayString(option.description), 1)
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ], 32))
        : (_openBlock(), _createBlock("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.resultsIntro), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.drafts, (draft, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "suggest-caption-dialog__draft card mb-3"
              }, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, "Draft " + _toDisplayString(index + 1), 1),
                      _createVNode("div", _hoisted_23, _toDisplayString(draft.text), 1)
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary flex-shrink-0",
                      onClick: ($event: any) => (_ctx.useDraft(draft.text))
                    }, " Use this ", 8, ["onClick"])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.creditsRemaining != null)
              ? (_openBlock(), _createBlock("div", _hoisted_24, " AI credits remaining: " + _toDisplayString(_ctx.creditsRemaining), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClosed"]))
})